import { useSearchParams } from 'react-router-dom';

export interface TableState {
  page: number;
  pageSize: number;
  sortField?: string;
  sortOrder?: 'ascend' | 'descend';
  search?: string;
}

export function useTableState(defaults?: Partial<TableState>) {
  const [params, setParams] = useSearchParams();

  const state: TableState = {
    page: Number(params.get('page') ?? defaults?.page ?? 1),
    pageSize: Number(params.get('pageSize') ?? defaults?.pageSize ?? 20),
    sortField: params.get('sortField') ?? defaults?.sortField ?? undefined,
    sortOrder: (params.get('sortOrder') as 'ascend' | 'descend' | null) ?? defaults?.sortOrder ?? undefined,
    search: params.get('search') ?? defaults?.search ?? undefined,
  };

  const setTableState = (patch: Partial<Record<keyof TableState, string | number | undefined>>) => {
    const next = new URLSearchParams(params);
    Object.entries(patch).forEach(([k, v]) => {
      if (v === undefined || v === '') next.delete(k);
      else next.set(k, String(v));
    });
    // Reset to page 1 when filter/sort changes (not when page itself changes)
    if (patch.page === undefined && Object.keys(patch).some((k) => k !== 'page' && k !== 'pageSize')) {
      next.set('page', '1');
    }
    setParams(next, { replace: true });
  };

  return { ...state, setTableState };
}
